import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { buttonClass, type ButtonSize, type ButtonVariant } from './Button';
import { spring } from '../../utils/motion';
const MotionLink = motion(Link);
interface ButtonLinkProps {
  to: string;
  variant?: ButtonVariant;
  size?: ButtonSize;
  icon?: React.ReactNode;
  className?: string;
  children: React.ReactNode;
  onClick?: () => void;
}
export function ButtonLink({
  to,
  variant = 'primary',
  size = 'md',
  icon,
  className,
  children,
  onClick
}: ButtonLinkProps) {
  return <MotionLink to={to} onClick={onClick} whileHover={{
    scale: 1.03
  }} whileTap={{
    scale: 0.96
  }} transition={spring.snappy} className={buttonClass(variant, size, className)} data-id="element-770" data-mp="1woa6c9am04wo">
      {icon}
      {children}
    </MotionLink>;
}